
import {
    UPDATE_BREAKWATER_DRIVE_SUCCESS,
  } from '../actions/types';
  
  const INITIAL_STATE = {
    breakwaterDrive: null,
  };
  
  export default function breakwaterReducer (state=INITIAL_STATE, action) {
    switch (action.type) {
      case UPDATE_BREAKWATER_DRIVE_SUCCESS:
        return { ...state, breakwaterDrive: action.payload.breakwater_drive };
      default:
        return state;
    }
  };